import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Activation from '@/components/Activation'
import search from '@/components/search'
import BuyCar from '@/components/BuyCar'
import Details from '@/components/Details'
import Configure from '@/components/Configure'
import SellCar from '@/components/SellCar'
import CarInfo from '@/components/CarInfo'
import Evaluation from '@/components/Evaluation'
import Brand from '@/components/Brand'
import City from '@/components/City'
import Rights from '@/components/Rights'
import Explain from '@/components/Explain'
import Novice from '@/components/Novice'
import DetailsImg from '@/components/DetailsImg'
import Video from '@/components/Video'
import Video1 from '@/components/Video1'
import Video2 from '@/components/Video2'
import Video3 from '@/components/Video3'
import Media from '@/components/Media'
import Download from '@/components/Download'
import invitation from '@/components/invitation'
import downApp from '@/components/downApp'
import userAgreement from '@/components/userAgreement'
import privacyClause from '@/components/privacyClause'
import orderConfirm from '@/components/orderConfirm'
import byStages from '@/components/byStages'
import carDetails from '@/components/carDetails'
import carConfigure from '@/components/carConfigure'
import OAprivacyClause from '@/components/OAprivacyClause'
import OAuserAgreement from '@/components/OAuserAgreement'
import CPprivacyClause from '@/components/CPprivacyClause'
import CPuserAgreement from '@/components/CPuserAgreement'
import HCPprivacyClause from '@/components/HCPprivacyClause'
import HCPuserAgreement from '@/components/HCPuserAgreement'
import wuliuprivacyClause from '@/components/wuliuprivacyClause'
import wuliuuserAgreement from '@/components/wuliuuserAgreement'
import sitongprivacyClause from '@/components/sitongprivacyClause'
import sitonguserAgreement from '@/components/sitonguserAgreement'
import tdprivacyClause from '@/components/tdprivacyClause'
import tduserAgreement from '@/components/tduserAgreement'
import cqzlprivacyClause from '@/components/cqzlprivacyClause'
import cqzluserAgreement from '@/components/cqzluserAgreement'
import yhdprivacyClause from '@/components/yhdprivacyClause'
import yhduserAgreement from '@/components/yhduserAgreement'
import cdpprivacyClause from '@/components/cdpprivacyClause'
import cdpuserAgreement from '@/components/cdpuserAgreement'
import rsdprivacyClause from '@/components/rsdprivacyClause'
import rsduserAgreement from '@/components/rsduserAgreement'
import bangsongprivacyClause from '@/components/bangsongprivacyClause'
import bangsonguserAgreement from '@/components/bangsonguserAgreement'
import bangsongprivacyClauseHZ from '@/components/bangsongprivacyClauseHZ'
import bangsonguserAgreementHZ from '@/components/bangsonguserAgreementHZ'
import zZprivacyClause from '@/components/zZprivacyClause'
import zZuserAgreement from '@/components/zZuserAgreement'
import qmyprivacyClause from '@/components/qmyprivacyClause'
import qmyuserAgreement from '@/components/qmyuserAgreement'
import yshprivacyClause from '@/components/yshprivacyClause'
import yshuserAgreement from '@/components/yshuserAgreement'
import ddtprivacyClause from '@/components/ddtprivacyClause'
import ddtuserAgreement from '@/components/ddtuserAgreement'
import lkctprivacyClause from '@/components/lkctprivacyClause'
import lkctuserAgreement from '@/components/lkctuserAgreement'
import xinanprivacyClause from '@/components/xinanprivacyClause'
import xinanuserAgreement from '@/components/xinanuserAgreement'
import mdcprivacyClause from '@/components/mdcprivacyClause'
import mdcuserAgreement from '@/components/mdcuserAgreement'
import zhongnanprivacyClause from '@/components/zhongnanprivacyClause'
import zhongnanuserAgreement from '@/components/zhongnanuserAgreement'

import qrCode from '@/components/qrCode'
Vue.use(Router)

export default new Router({
    routes: [{
            path: '/login',
            name: 'Login',
            component: Login,
            meta: 10
        },
        {
            path: '/Activation',
            name: 'Activation',
            component: Activation
        },
        {
            path: '/search',
            name: 'search',
            component: search,
            meta: {
                title: "搜索",
                content: 'disable'
            }
        },
        {
            path: '/BuyCar',
            name: 'BuyCar',
            component: BuyCar,
            meta: {
                index: 2,
                title: "联联车",
                content: 'disable'
            }
        },
        {
            path: '/Details/:id',
            name: 'Details',
            component: Details,
            meta: {
                index: 3,
                title: "车辆详情",
                content: 'disable'
            }
        },
        {
            path: '/Configure/:id',
            name: 'Configure',
            component: Configure,
            meta: {
                title: "参数配置",
                content: 'disable'
            }
        },
        {
            path: '/carConfigure/:id',
            name: 'carConfigure',
            component: carConfigure,
            meta: {
                title: "参数配置",
                content: 'disable'
            }
        },
        {
            path: '/SellCar',
            name: 'SellCar',
            component: SellCar,
            meta: {
                title: "卖车",
                content: 'disable'
            }
        },
        {
            path: '/CarInfo/:id',
            name: 'CarInfo',
            component: CarInfo,
            meta: {
                title: "车辆信息",
                content: 'disable'
            }
        },
        {
            path: '/Evaluation',
            name: 'Evaluation',
            component: Evaluation,
            meta: {
                title: "估价",
                content: 'disable'
            }
        },
        {
            path: '/Brand',
            name: 'Brand',
            component: Brand,
            meta: {
                title: "品牌",
                content: 'disable'
            }
        },
        {
            path: '/City',
            name: 'City',
            component: City,
            meta: {
                index: 3,
                title: "城市",
                content: 'disable'
            }
        },
        {
            path: '/Rights',
            name: 'Rights',
            component: Rights,
            meta: {
                title: "权益说明",
                content: 'disable'
            }
        },
        {
            path: '/Explain',
            name: 'Explain',
            component: Explain,
            meta: {
                title: "马力说明",
                content: 'disable'
            }
        },
        {
            path: '/Novice',
            name: 'Novice',
            component: Novice,
            meta: {
                title: "新手指引",
                content: 'disable'
            }
        },
        {
            path: '/DetailsImg',
            name: 'DetailsImg',
            component: DetailsImg,
        },
        {
            path: '/Video',
            name: 'Video',
            component: Video,
            meta: {
                title: "联联车视频说明",
                content: 'disable'
            }
        },
        {
            path: '/Video1',
            name: 'Video1',
            component: Video1,
            meta: {
                title: "买车卖车视频",
                content: 'disable'
            }
        },
        {
            path: '/Video2',
            name: 'Video2',
            component: Video2,
            meta: {
                title: "车达人获得马力",
                content: 'disable'
            }
        },
        {
            path: '/Video3',
            name: 'Video3',
            component: Video3,
            meta: {
                title: "邀请视频",
                content: 'disable'
            }
        },
        {
            path: '/Media',
            name: 'Media',
            component: Media,
            meta: {
                title: "媒体报道",
                content: 'disable'
            }
        },
        {
            path: '/Download',
            name: 'Download',
            component: Download,
            meta: {
                title: "联联车金融下载",
                content: 'disable'
            }
        },
        {
            path: '/downApp',
            name: 'downApp',
            component: downApp,
            meta: {
                title: "联联车下载",
                content: 'disable'
            }
        },
        {
            path: '/invitation',
            name: 'invitation',
            component: invitation,
            meta: {
                title: "邀请加入",
                content: 'disable'
            }
        },
        {
            path: '/userAgreement',
            name: 'userAgreement',
            component: userAgreement,
            meta: {
                title: "用户协议",
                content: 'disable'
            }
        },
        {
            path: '/privacyClause',
            name: 'privacyClause',
            component: privacyClause,
            meta: {
                title: "联联车隐私政策条款",
                content: 'disable'
            }
        },
        {
            path: '/orderConfirm',
            name: 'orderConfirm',
            component: orderConfirm,
            meta: {
                title: "确认订单",
                content: 'disable'
            }
        },
        {
            path: '/byStages',
            name: 'byStages',
            component: byStages,
            meta: {
                title: "分期购",
                content: 'disable'
            }
        },
        {
            path: '/carDetails/:id',
            name: 'carDetails',
            component: carDetails,
            meta: {
                title: "车详情",
                content: 'disable'
            }
        },
        {
            path: '/OAprivacyClause',
            name: 'OAprivacyClause',
            component: OAprivacyClause,
            meta: {
                title: "隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/OAuserAgreement',
            name: 'OAuserAgreement',
            component: OAuserAgreement,
            meta: {
                title: "用户协议",
                content: 'disable'
            }
        },
        {
            path: '/CPprivacyClause',
            name: 'CPprivacyClause',
            component: CPprivacyClause,
            meta: {
                title: "青风车隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/CPuserAgreement',
            name: 'CPuserAgreement',
            component: CPuserAgreement,
            meta: {
                title: "青风车用户协议",
                content: 'disable'
            }
        },
        {
            path: '/HCPprivacyClause',
            name: 'HCPprivacyClause',
            component: HCPprivacyClause,
            meta: {
                title: "汇仓配隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/HCPuserAgreement',
            name: 'HCPuserAgreement',
            component: HCPuserAgreement,
            meta: {
                title: "汇仓配用户协议",
                content: 'disable'
            }
        },
        {
            path: '/wuliuprivacyClause',
            name: 'wuliuprivacyClause',
            component: wuliuprivacyClause,
            meta: {
                title: "五六科技隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/wuliuuserAgreement',
            name: 'wuliuuserAgreement',
            component: wuliuuserAgreement,
            meta: {
                title: "五六科技用户协议",
                content: 'disable'
            }
        },
        {
            path: '/sitongprivacyClause',
            name: 'sitongprivacyClause',
            component: sitongprivacyClause,
            meta: {
                title: "四通网运隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/sitonguserAgreement',
            name: 'sitonguserAgreement',
            component: sitonguserAgreement,
            meta: {
                title: "四通网运用户协议",
                content: 'disable'
            }
        },
        {
            path: '/tdprivacyClause',
            name: 'tdprivacyClause',
            component: tdprivacyClause,
            meta: {
                title: "泰达物流隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/tduserAgreement',
            name: 'tduserAgreement',
            component: tduserAgreement,
            meta: {
                title: "泰达物流用户协议",
                content: 'disable'
            }
        },
        {
            path: '/cqzlprivacyClause',
            name: 'cqzlprivacyClause',
            component: cqzlprivacyClause,
            meta: {
                title: "山海卓荦隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/cqzluserAgreement',
            name: 'cqzluserAgreement',
            component: cqzluserAgreement,
            meta: {
                title: "山海卓荦用户协议",
                content: 'disable'
            }
        },
        {
            path: '/yhdprivacyClause',
            name: 'yhdprivacyClause',
            component: yhdprivacyClause,
            meta: {
                title: "云货滴隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/yhduserAgreement',
            name: 'yhduserAgreement',
            component: yhduserAgreement,
            meta: {
                title: "云货滴用户协议",
                content: 'disable'
            }
        },
        {
            path: '/cdpprivacyClause',
            name: 'cdpprivacyClause',
            component: cdpprivacyClause,
            meta: {
                title: "车道聘隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/cdpuserAgreement',
            name: 'cdpuserAgreement',
            component: cdpuserAgreement,
            meta: {
                title: "车道聘用户协议",
                content: 'disable'
            }
        },
        {
            path: '/rsdprivacyClause',
            name: 'rsdprivacyClause',
            component: rsdprivacyClause,
            meta: {
                title: "哒哒隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/rsduserAgreement',
            name: 'rsduserAgreement',
            component: rsduserAgreement,
            meta: {
                title: "哒哒用户协议",
                content: 'disable'
            }
        },
        {
            path: '/bangsongprivacyClause',
            name: 'bangsongprivacyClause',
            component: bangsongprivacyClause,
            meta: {
                title: "邦送隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/bangsonguserAgreement',
            name: 'bangsonguserAgreement',
            component: bangsonguserAgreement,
            meta: {
                title: "邦送用户协议",
                content: 'disable'
            }
        },
        {
            path: '/bangsongprivacyClauseHZ',
            name: 'bangsongprivacyClauseHZ',
            component: bangsongprivacyClauseHZ,
            meta: {
                title: "邦送货主隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/bangsonguserAgreementHZ',
            name: 'bangsonguserAgreementHZ',
            component: bangsonguserAgreementHZ,
            meta: {
                title: "邦送货主用户协议",
                content: 'disable'
            }
        },
        {
            path: '/zZprivacyClause',
            name: 'zZprivacyClause',
            component: zZprivacyClause,
            meta: {
                title: "中赞网络货运隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/zZuserAgreement',
            name: 'zZuserAgreement',
            component: zZuserAgreement,
            meta: {
                title: "中赞网络货运用户协议",
                content: 'disable'
            }
        },
        {
            path: '/qmyprivacyClause',
            name: 'qmyprivacyClause',
            component: qmyprivacyClause,
            meta: {
                title: "黔满运网络货运隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/qmyuserAgreement',
            name: 'qmyuserAgreement',
            component: qmyuserAgreement,
            meta: {
                title: "黔满运网络货运用户协议",
                content: 'disable'
            }
        },
        {
            path: '/yshprivacyClause',
            name: 'yshprivacyClause',
            component: yshprivacyClause,
            meta: {
                title: "一水晗隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/yshuserAgreement',
            name: 'yshuserAgreement',
            component: yshuserAgreement,
            meta: {
                title: "一水晗用户协议",
                content: 'disable'
            }
        },
        {
            path: '/ddtprivacyClause',
            name: 'ddtprivacyClause',
            component: ddtprivacyClause,
            meta: {
                title: "达达兔隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/ddtuserAgreement',
            name: 'ddtuserAgreement',
            component: ddtuserAgreement,
            meta: {
                title: "达达兔用户协议",
                content: 'disable'
            }
        },
        {
            path: '/lkctprivacyClause',
            name: 'lkctprivacyClause',
            component: lkctprivacyClause,
            meta: {
                title: "鹭卡畅通隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/lkctuserAgreement',
            name: 'lkctuserAgreement',
            component: lkctuserAgreement,
            meta: {
                title: "鹭卡畅通用户协议",
                content: 'disable'
            }
        },
        {
            path: '/xinanprivacyClause',
            name: 'xinanprivacyClause',
            component: xinanprivacyClause,
            meta: {
                title: "杺桉物联隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/xinanuserAgreement',
            name: 'xinanuserAgreement',
            component: xinanuserAgreement,
            meta: {
                title: "杺桉物联用户协议",
                content: 'disable'
            }
        },
        {
            path: '/mdcprivacyClause',
            name: 'mdcprivacyClause',
            component: mdcprivacyClause,
            meta: {
                title: "蛮多车隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/mdcuserAgreement',
            name: 'mdcuserAgreement',
            component: mdcuserAgreement,
            meta: {
                title: "蛮多车用户协议",
                content: 'disable'
            }
        },
        {
            path: '/zhongnanprivacyClause',
            name: 'zhongnanprivacyClause',
            component: zhongnanprivacyClause,
            meta: {
                title: "中南跨境通隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/zhongnanuserAgreement',
            name: 'zhongnanuserAgreement',
            component: zhongnanuserAgreement,
            meta: {
                title: "中南跨境通用户协议",
                content: 'disable'
            }
        },
        {
            path: '/qrCode',
            name: 'qrCode',
            component: qrCode,
            meta: {
                title: "二维码信息",
                content: 'disable'
            }
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js